import { NetworkStatus } from '@features/eInvoicing/types'

import { getIsAppTestingEnvironment } from '../../../../utils/getIsAppTestingEnvironment'

export const getIsPdpPpfStatusApproved = (eInvoiceIntegrationPdpNetworkStatus: NetworkStatus | undefined) => {
  // In staging the status is never meant to go further than noChangeRequired
  // But we can check for the approved ones as well just in case
  const isTestingEnvironment = getIsAppTestingEnvironment()
  if (isTestingEnvironment) {
    return ['approvedByPpf', 'appliedInPpf', 'noChangeRequired'].includes(
      eInvoiceIntegrationPdpNetworkStatus?.ppfStatus ?? '',
    )
  }

  return (
    eInvoiceIntegrationPdpNetworkStatus?.ppfStatus === 'approvedByPpf' ||
    eInvoiceIntegrationPdpNetworkStatus?.ppfStatus === 'appliedInPpf'
  )
}
